// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file subscription/v1/shopify_plan.proto (package subscription.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Addon } from './addon_pb';
import { file_subscription_v1_addon } from './addon_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file subscription/v1/shopify_plan.proto.
 */
export const file_subscription_v1_shopify_plan: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CiJzdWJzY3JpcHRpb24vdjEvc2hvcGlmeV9wbGFuLnByb3RvEg9zdWJzY3JpcHRpb24udjEijAEKC1Nob3BpZnlQbGFuEg4KBmhhbmRsZRgBIAEoCRImCgZhZGRvbnMYAiADKAsyFi5zdWJzY3JpcHRpb24udjEuQWRkb24SDAoEbmFtZRgDIAEoCRISCgp0cmlhbF9kYXlzGAQgASgFEg4KBmxlZ2FjeRgFIAEoCBITCgt1c2FnZV9iYXNlZBgGIAEoCEKKAQoTY29tLnN1YnNjcmlwdGlvbi52MUIQU2hvcGlmeVBsYW5Qcm90b1ABWgQuL3BiogIDU1hYqgIPU3Vic2NyaXB0aW9uLlYxygIPU3Vic2NyaXB0aW9uXFYx4gIbU3Vic2NyaXB0aW9uXFYxXEdQQk1ldGFkYXRh6gIQU3Vic2NyaXB0aW9uOjpWMWIGcHJvdG8z',
        [file_subscription_v1_addon]
    );

/**
 * @generated from message subscription.v1.ShopifyPlan
 */
export type ShopifyPlan = Message<'subscription.v1.ShopifyPlan'> & {
    /**
     * @generated from field: string handle = 1;
     */
    handle: string;

    /**
     * @generated from field: repeated subscription.v1.Addon addons = 2;
     */
    addons: Addon[];

    /**
     * @generated from field: string name = 3;
     */
    name: string;

    /**
     * @generated from field: int32 trial_days = 4;
     */
    trialDays: number;

    /**
     * @generated from field: bool legacy = 5;
     */
    legacy: boolean;

    /**
     * @generated from field: bool usage_based = 6;
     */
    usageBased: boolean;
};

/**
 * Describes the message subscription.v1.ShopifyPlan.
 * Use `create(ShopifyPlanSchema)` to create a new message.
 */
export const ShopifyPlanSchema: GenMessage<ShopifyPlan> =
    /*@__PURE__*/
    messageDesc(file_subscription_v1_shopify_plan, 0);
